import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSectionActivities(id: string | undefined) {
  return useQuery(queries.locations.getSectionActivitiesById(id || ''))
}
